const STORAGE_KEY = 'lottozahlengenerator_history';
const MAX_HISTORY_ITEMS = 10;

export const saveToHistory = (numbers, superzahl) => {
  try {
    const history = getHistory();
    const newEntry = {
      numbers: [...numbers],
      superzahl,
      timestamp: new Date().toISOString()
    };
    
    // Add new entry at the beginning
    const updatedHistory = [newEntry, ...history].slice(0, MAX_HISTORY_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
    return updatedHistory;
  } catch (error) {
    console.error('Error saving to history:', error);
    return [];
  }
};

export const getHistory = () => {
  try {
    const history = localStorage.getItem(STORAGE_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    console.error('Error reading history:', error);
    return [];
  }
};

export const clearHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing history:', error);
    return false;
  }
};

export const getNumberFrequency = () => {
  const history = getHistory();
  const frequency = {};
  
  history.forEach(entry => {
    entry.numbers.forEach(num => {
      frequency[num] = (frequency[num] || 0) + 1;
    });
  });
  
  return frequency;
};


